<template>
  <header class="navbar bg-white is-sticky px-4 md:px-10 2xl:px-24">
    <div class="navbar-start">
      <div class="logo mr-3">
        <router-link :to="{ name: 'room-home-page' }">
          <img src="@assets/images/logo/logo.svg" alt="Liveet" class="hidden lg:block" />
          <img src="@assets/images/logo/logo-icon.svg" alt="Liveet" class="block lg:hidden" />
        </router-link>
      </div>

      <button v-if="false" data-drawer-target="logo-sidebar" data-drawer-toggle="logo-sidebar" aria-controls="logo-sidebar" type="button" class="inline-flex items-center p-2 text-sm text-theme-orange-01 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200">
        <span class="sr-only">Open sidebar</span>
        <svg aria-hidden="true" class="w-6 h-6" fill="currentColor" viewbox="0 0 20 20"><path clip-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z" fill-rule="evenodd"></path></svg>
      </button>
    </div>

    <template v-if="$route.name !== 'checkin'">
      <div v-if="loggedIn" class="navbar-end">
        <!-- desktop menu -->
        <div class="hidden lg:flex">
          <ul class="menu menu-horizontal compact p-0">
            <li>
              <router-link :to="{ name: 'room-home-page' }" class="p-4">
                <svg class="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M4.20619 11.1274C4.20619 10.0203 4.19378 4.98841 4.18638 2.08458C4.18344 0.930669 3.24717 0 2.09325 0C0.937182 0 0 0.935539 0 2.09161V11.1274C0 16.2999 4.64488 18 6.89691 18H15C14.5928 16.6537 12.8691 13.961 9.23196 13.961C5.59485 13.961 4.20619 12.7053 4.20619 11.1274Z" fill="currentColor" />
                </svg>
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'multimedia' }" class="p-4">
                <svg class="w-5 h-5" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="9" y1="21" x2="9" y2="9"></line>
                </svg>
                Media
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'room-guest-list' }" class="p-4">
                <svg class="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                Guest List
              </router-link>
            </li>
          </ul>
        </div>

        <!-- mobile menu -->
        <div class="lg:hidden block fixed inset-x-0 bottom-0 z-10 bg-white shadow">
          <ul class="menu menu-horizontal compact mobile py-1">
            <li>
              <router-link :to="{ name: 'room-home-page' }" class="p-4">
                <svg class="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M4.20619 11.1274C4.20619 10.0203 4.19378 4.98841 4.18638 2.08458C4.18344 0.930669 3.24717 0 2.09325 0C0.937182 0 0 0.935539 0 2.09161V11.1274C0 16.2999 4.64488 18 6.89691 18H15C14.5928 16.6537 12.8691 13.961 9.23196 13.961C5.59485 13.961 4.20619 12.7053 4.20619 11.1274Z" fill="currentColor" />
                </svg>
                Home
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'multimedia' }" class="p-4">
                <svg class="w-5 h-5" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="3" y1="9" x2="21" y2="9"></line>
                  <line x1="9" y1="21" x2="9" y2="9"></line>
                </svg>
                Media
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'room-guest-list' }" class="p-4">
                <svg class="h-5 w-5" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                Guest List
              </router-link>
            </li>
          </ul>
        </div>

        <button class="button button-theme-01 py-1 md:ml-3" @click="handleLogout">Logout</button>
      </div>
      <div v-else class="navbar-end">
        <router-link :to="{ name: 'login' }" class="button button-theme-01 py-1 md:ml-3">Login</router-link>
      </div>
    </template>
  </header>
</template>

<script>
import { authComputed } from '@state/helpers'

export default {
  computed: {
    ...authComputed
  },
  methods: {
    async handleLogout() {
      try {
        await this.$store.dispatch('auth/logOut')

        this.$router.push({ name: 'login' })
      } catch (error) {
        console.error('Logout failed:', error)
      }
    }
  }
}
</script>
